export default __webpack_public_path__ + "images/befbec195e40b9eac7074ce76ed83075.png";